import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { formatearNumeroEntero, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import moment from 'moment';
import { formatearLabel } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormCon06 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            ivaParam: null,
            vecesParam: null, 
            empresa: null,

            fechaDesde: null,
            fechaHasta: null,
        };

        this.changeComponents = this.changeComponents.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.generarATS = this.generarATS.bind(this);
    }

    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('08');
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");

        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})
    }

    changeYear(){
        if(this.state.periodo!==''){
            let anio = formatearNumeroEntero(this.state.periodo);
            let fechaInf = formatearNumeroEntero(this.state.anioActual) - 10;

            if(anio>formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
            }else if(anio===formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: anio});
            }else if(anio >= fechaInf && anio <=formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: anio});
            }else{
                this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
                alert("Sólo puede consultar información de los últimos 10 años.");
            }
        }
    }

    componentDidMount(){
        Promise.all([            
            cargarCatalogos_Otros('PARAMS-VECES'), cargarCatalogos_Otros('COM-IVAPG'),         
            cargarCatalogos_Otros('PARAMS-COMPANI'),this.props.generar_LogAuditoriaIngresoForm('0806')
         ])
        .then(([ veces, iva, empresa]) => {

            let fechaProceso = getFechaProcesoPorModulo('08');
            let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
            let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");

            this.setState({ vecesParam: formatearLabel(veces[0].label), ivaParam: parseInt(iva[0].value, 10), empresa: empresa[0].value,
                fechaDesde: fechaDesde, fechaHasta: fechaHasta })
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0806');
    }

    generarATS(){
        var proceder = true;
        var error = "";
        var data = {};

        if(this.state.fechaDesde===null && this.state.fechaHasta===null){
            proceder = false;
            error = error + "- Ingrese un rango de fechas para continuar\n"
        }else{
            if(this.state.fechaDesde.isValid()===false || this.state.fechaHasta.isValid()===false){
                proceder = false;
                error = error + "- Las fechas no son válidas\n"
            }else{
                var desde = formatearFechaMoment_a_String(this.state.fechaDesde).split("/");
                var hasta = formatearFechaMoment_a_String(this.state.fechaHasta).split("/");
                if(desde[2]!==hasta[2]){
                    proceder = false;
                    error = error + "- Ambas fechas deben estar en el mismo año\n"
                }else{
                    data.Periodo = desde[2];
                }

                if(desde[1]!==hasta[1]){
                    proceder = false;
                    error = error + "- Ambas fechas deben estar en el mismo mes\n"
                }else{
                    data.Mes = desde[1];
                }
            }
        }

        if(proceder===true){
            let resp = window.confirm("Generar ATS sobre el mes y año actual")
            if(resp){
                
                data.fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde)
                data.fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta)
                data.Empresa = this.state.empresa;
                data.Iva = parseInt(this.state.ivaParam,10)/100;
                data.codEstablecimiento = this.state.vecesParam;

                let config_request = {
                    method: 'POST',
                    url: '/ats',
                    data,
                    responseType: 'xml'
                }

                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then((response)=> {  
                    this.props.cambiar_VisualizacionLoading(false);

                    const url = window.URL.createObjectURL(new Blob([response.data], {type: "text/xml"}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'AT' +desde[1]+desde[2]+'.xml');
                    document.body.appendChild(link);
                    link.click();   
                    
                })
                .catch((error)=>{  
                    this.props.cambiar_VisualizacionLoading(false);                         
                    alert(error.response?error.response.data.msg:error.message);
                });
            }
        }else{
            alert(error)
        }
    }

    render(){
        return(
            <ContenedorForm porc_ancho={50}>
                <HeaderForm>
                    <TituloForm>Generación de ATS</TituloForm>
                </HeaderForm>
                    <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='8'>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>                        
                    </Row>               
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={this.generarATS}><i className="fa fa-cog" aria-hidden="true"/><span className="sr-only">Loading...</span> Generar</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                    </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel,        
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        departamento : state.sesion.valoresSesionForm.Departamento}
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCon06);